import { defineComponent as _defineComponent } from 'vue'
import { ref, onBeforeMount, onMounted } from 'vue';

import { Options, SeriesOptionsType } from 'highcharts';
import { Chart } from 'highcharts-vue';
import {
  configureBarChartOptions,
  configureBarChartAllocationOptions
} from './helpers';

interface Props {
  labels: string[];
  series: SeriesOptionsType[];
  height?: string;
  maxAxisY?: number;
  useAllocationOptions?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'BarChart',
  props: {
    labels: null,
    series: null,
    height: { default: '450' },
    maxAxisY: { default: undefined },
    useAllocationOptions: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { labels: string[], series: SeriesOptionsType[], height: string, maxAxisY: number, useAllocationOptions: boolean };



const highchartsRef = ref();
const chartOptions = ref<Options>();

function setChartOptions() {
  chartOptions.value = props.useAllocationOptions
    ? configureBarChartAllocationOptions(props.series)
    : configureBarChartOptions(props.series, props.labels, props.maxAxisY);
}

onBeforeMount(() => {
  // prevent chart flick
  chartOptions.value = {
    chart: {
      height: props.height
    }
  };
});

onMounted(() => {
  setChartOptions();
});

return { __sfc: true,props, highchartsRef, chartOptions, setChartOptions, Chart }
}

})